import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./Components/Layout";
import DonateForm from "./Components/DonateForm";
import ThankYou from "./Components/Thankyou";
import NotFound from "./Components/NotFound";
import CelebrationPage from "./Components/Celebration/CelebrationPage";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'


const App = () => {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<Layout><DonateForm /></Layout>} /> 
      <Route path="/thankYou/:orderId" element={<Layout><ThankYou /></Layout>} />
      <Route path="/celebration" element={<Layout><CelebrationPage /></Layout>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Router>
  );
};

export default App;
